import { inject, Injectable } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { firstValueFrom } from "rxjs";
import { MessagePopup } from "./message-popup";
import { MessagePopupSeverity } from "./message-popup-data.model";

@Injectable({
  providedIn: 'root'
})
export class MessagePopupService {

  private dialog: MatDialog = inject(MatDialog);

  showMessage(
    text: string,
    severity: MessagePopupSeverity,
    confirmText: string = '',
    cancelText: string = 'Închide',
    options: { disableClose?: boolean } = {},
  ): Promise<boolean> {
    const config = new MatDialogConfig();
    config.disableClose = options.disableClose ?? true;
    config.autoFocus = true;
    config.data = { text, severity, confirmText, cancelText };

    const close$ = this.dialog.open(MessagePopup, config)
      .afterClosed();

    return firstValueFrom(close$);
  }
}